import { IUseFetch } from 'hooks/use-fetch/use-fetch.interface';

export const submitFetchConfig: IUseFetch = {
  loadingKey: 'damageEditForm',
  isShowSuccessSnackbar: true
};
